import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorRoll: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColorRoll"><Path d="M6 3H21V11H6V8H5V12H14V15.1707C15.1652 15.5825 16 16.6938 16 18V22H14V18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18V22H10V18C10 16.6938 10.8348 15.5825 12 15.1707V14H3V6H6V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColorRoll;
